var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 8.9908C7.47146 8.9908 8.66536 7.7969 8.66536 6.32414C8.66536 4.85138 7.47146 3.65747 5.9987 3.65747C4.52594 3.65747 3.33203 4.85138 3.33203 6.32414C3.33203 7.7969 4.52594 8.9908 5.9987 8.9908Z",
    stroke: "#9BA4AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 12.9908C10.6654 10.7815 8.57603 8.9908 5.9987 8.9908C3.42136 8.9908 1.33203 10.7815 1.33203 12.9908M9.9987 8.9908C10.4443 8.99078 10.8828 8.8791 11.2741 8.66596C11.6654 8.45283 11.9971 8.14503 12.2388 7.7707C12.4805 7.39636 12.6245 6.96743 12.6578 6.52308C12.691 6.07873 12.6124 5.63314 12.4291 5.227C12.2457 4.82087 11.9636 4.46716 11.6083 4.19817C11.2531 3.92918 10.8361 3.7535 10.3955 3.68718C9.95484 3.62085 9.50462 3.666 9.08594 3.8185C8.66725 3.97099 8.29346 4.22597 7.9987 4.56014",
    stroke: "#9BA4AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 12.9908C14.6667 10.7815 12.5773 8.99081 10 8.99081C9.462 8.99081 8.598 8.79548 8 8.16748",
    stroke: "#9BA4AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsIcon);
export default __webpack_public_path__ + "static/media/patients-icon.8ef2a0322c9d7a67435ecfabfbaa1c40.svg";
export { ForwardRef as ReactComponent };